import * as React from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

/**
 * React Hook that returns the current window size
 * and report updates from the 'resize' window event
 *
 * @typedef {useIsMobile} useIsMobile
 * @property {number} isNarrower Window width judgment...
 * @returns {isNarrower} A value representing whether the width is less than 768
 */

const useIsNarrowerThan = (width: number): boolean => {
    const initialWidth =
        // @ts-ignore // get width from
        (typeof global !== 'undefined' && global.width) ||
        // @ts-ignore
        (typeof window !== 'undefined' && window?.__data?.windowSize?.width) ||
        1024;

    const [isNarrower, setIsNarrower] = React.useState(initialWidth < width);

    useIsomorphicLayoutEffect(() => {
        setIsNarrower(window.innerWidth < width);
    }, []);

    const handleResize = React.useCallback(() => {
        if (isNarrower !== window.innerWidth < width) {
            setIsNarrower(window.innerWidth < width);
        }
    }, [isNarrower, width]);

    React.useEffect(() => {
        // Add event listener for window resize events
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        // Remove event listener
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    });

    return isNarrower;
};

export default useIsNarrowerThan;
